import { adTechLog } from '../../general/log';
import { skipPrerequisites } from "../../general/prerequisites";

const { services } = window.adTechConfig;

export const moatIsOn = () => {
	return services.moat ? services.moat : false;
};

export const moatIsReady = () => {
	return moatIsOn && 'undefined' !== typeof window.moatPrebidApi;
};

export const moatSetTargetingForAllSlots = () => {

	if ( ! skipPrerequisites() &&
		moatIsReady() &&
		'function' === typeof window.moatPrebidApi.setMoatTargetingForAllSlots ) {

		window.moatPrebidApi.setMoatTargetingForAllSlots();
		
		adTechLog( {
			type: 'pass',
			message: `Moat - Set targeting for all slots.`,
		} );
	}
};

export const moatSetTargetingForSlot = ( adSlot, adSlotID ) => {
	if ( ! skipPrerequisites() &&
		moatIsReady() &&
		'function' === typeof window.moatPrebidApi.setMoatTargetingForSlot ) {

		window.moatPrebidApi.setMoatTargetingForSlot( adSlot );

		adTechLog( {
			type: 'pass',
			message: `Moat - Ad slot sent to Moat, for element id: "${ adSlotID }"`,
		} );
	}
};

export const moatSafetyDataAvailable = () => {
	if ( ! skipPrerequisites() &&
		moatIsReady() &&
		'function' === typeof window.moatPrebidApi.safetyDataAvailable ) {

		return window.moatPrebidApi.safetyDataAvailable();
	}

	return false;
};

export const moatSlotDataAvailable = ( adSlot ) => {
	if ( ! skipPrerequisites() &&
		moatIsReady() &&
		'function' === typeof window.moatPrebidApi.slotDataAvailable ) {

		return window.moatPrebidApi.slotDataAvailable( adSlot );
	}

	return false;
};
